import { reactive, watch, onUnmounted, ref, set, del, computed } from '@vue/composition-api'
import { mergeMessages, getI18n } from './language/index.js'
import { validate as uuidValidate } from 'uuid'

const messages = {
  'en-US': {
    validation: {
      default: 'Invalid {field}',
      domain: 'Invalid domain',
      email: 'Invalid email',
      malformedJSON: 'Malformed JSON',
      maxLength: '{field} cannot exceed {val} characters',
      minLength: '{field} must contain a minimum of {val} characters',
      passwordMatch: 'Passwords do not match',
      password: {
        lower: 'You need to include at least one lowercase character in the password',
        lowerNumeric: 'You need to include at least one lowercase and one numeric character in the password',
        lowerNumericSpecial: 'You need to include at least one lowercase, one numeric, and one special character in the password',
        lowerNumericSpecialUpper: 'You need to include at least one lowercase, one uppercase, one numeric, and one special character in the password',
        lowerNumericUpper: 'You need to include at least one lowercase, one uppercase, and one numeric character in the password',
        lowerSpecial: 'You need to include at least one lowercase and one special character in the password',
        lowerSpecialUpper: 'You need to include at least one lowercase, one uppercase, and one special character in the password',
        lowerUpper: 'You need to include at least one lowercase and one uppercase character in the password',
        numeric: 'You need to include at least one numeric character in the password',
        numericSpecial: 'You need to include at least one numeric and one special character in the password',
        numericSpecialUpper: 'You need to include at least one uppercase, one numeric, and one special character in the password',
        numericUpper: 'You need to include at least one uppercase and one numeric character in the password',
        special: 'You need to include at least one special character in the password',
        specialUpper: 'You need to include at least one uppercase and one special character in the password',
        upper: 'You need to include at least one uppercase character in the password'
      },
      regex: 'check {field}',
      required: '{field} required',
      numeric: 'Field must be numeric',
      thePassword: 'Password',
      uuid: 'Field must be UUID'
    }
  },
  'es-ES': {
    validation: {
      default: '{field} Inválido',
      domain: 'Dominio inválido',
      email: 'Correo electrónico inválido',
      malformedJSON: 'JSON mal formado',
      maxLength: '{field} no puede exceder de {val} carácteres',
      minLength: '{field} debe tener un mínimo de {val} carácteres',
      passwordMatch: 'Las contraseñas no coinciden',
      password: {
        lower: 'Debe incluir al menos una letra minúscula en la contraseña',
        lowerNumeric: 'Debe incluir al menos una letra minúscula y un número en la contraseña',
        lowerNumericSpecial: 'Debe incluir al menos una letra minúscula, un número y un carácter especial en la contraseña',
        lowerNumericSpecialUpper: 'Debe incluir al menos una letra minúscula, una letra mayúscula, un número y un carácter especial en la contraseña',
        lowerNumericUpper: 'Debe incluir al menos una letra minúscula, una letra mayúscula y un número en la contraseña',
        lowerSpecial: 'Debe incluir al menos una letra minúscula y un carácter especial en la contraseña',
        lowerSpecialUpper: 'Debe incluir al menos una letra minúscula, una letra mayúscula y un carácter especial en la contraseña',
        lowerUpper: 'Debe incluir al menos una letra minúscula y una letra mayúscula en la contraseña',
        numeric: 'Debe incluir al menos un número en la contraseña',
        numericSpecial: 'Debe incluir al menos un número y un carácter especial en la contraseña',
        numericSpecialUpper: 'Debe incluir al menos una letra mayúscula, un número y un carácter especial en la contraseña',
        numericUpper: 'Debe incluir al menos una letra mayúscula y un número en la contraseña',
        special: 'Debe incluir al menos un carácter especial en la contraseña',
        specialUpper: 'Debe incluir al menos una letra mayúscula y un carácter especial en la contraseña',
        upper: 'Debe incluir al menos una letra mayúscula en la contraseña'
      },
      regex: 'revise {field}',
      required: 'Se requiere {field}',
      numeric: 'El campo debe ser numérico',
      thePassword: 'La contraseña',
      uuid: 'El campo debe ser UUID'
    }
  },
  'ca-ES': {
    validation: {
      default: '{field} Invàlid',
      domain: 'Domini invàlid',
      email: 'Correu electrònic invàlid',
      malformedJSON: 'JSON mal format',
      maxLength: '{field} no pot excedir {val} caràcters',
      minLength: '{field} ha de tenir un mínim de {val} caràcters',
      passwordMatch: 'Les contrasenyes no coincideixen',
      password: {
        lower: 'Ha d\'incloure almenys una lletra minúscula en la contrasenya',
        lowerNumeric: 'Ha d\'incloure almenys una lletra minúscula i un número en la contrasenya',
        lowerNumericSpecial: 'Ha d\'incloure almenys una lletra minúscula, un número i un caràcter especial en la contrasenya',
        lowerNumericSpecialUpper: 'Ha d\'incloure almenys una lletra minúscula, una lletra majúscula, un número i un caràcter especial en la contrasenya',
        lowerNumericUpper: 'Ha d\'incloure almenys una lletra minúscula, una lletra majúscula i un número en la contrasenya',
        lowerSpecial: 'Ha d\'incloure almenys una lletra minúscula i un caràcter especial en la contrasenya',
        lowerSpecialUpper: 'Ha d\'incloure almenys una lletra minúscula, una lletra majúscula i un caràcter especial en la contrasenya',
        lowerUpper: 'Ha d\'incloure almenys una lletra minúscula i una lletra majúscula en la contrasenya',
        numeric: 'Ha d\'incloure almenys un número en la contrasenya',
        numericSpecial: 'Ha d\'incloure almenys un número i un caràcter especial en la contrasenya',
        numericSpecialUpper: 'Ha d\'incloure almenys una lletra majúscula, un número i un caràcter especial en la contrasenya',
        numericUpper: 'Ha d\'incloure almenys una lletra majúscula i un número en la contrasenya',
        special: 'Ha d\'incloure almenys un caràcter especial en la contrasenya',
        specialUpper: 'Ha d\'incloure almenys una lletra majúscula i un caràcter especial en la contrasenya',
        upper: 'Ha d\'incloure almenys una lletra majúscula en la contrasenya'
      },
      regex: 'revisi {field}',
      required: 'Es requereix {field}',
      numeric: 'El camp ha de ser numèric',
      thePassword: 'La contrasenya',
      uuid: 'El camp ha de ser UUID'
    }
  },
  'it-IT': {
    validation: {
      default: '{field} non valido',
      domain: 'Dominio non valido',
      email: 'Email non valida',
      malformedJSON: 'JSON non valido',
      maxLength: '{field} non può superare {val} caratteri',
      minLength: '{field} deve contenere un minimo di {val} caratteri',
      passwordMatch: 'Le password non corrispondono',
      password: {
        lower: 'La password deve contenere almeno una lettera minuscola',
        lowerNumeric: 'La password deve contenere almeno una lettera minuscola e un numero',
        lowerNumericSpecial: 'La password deve contenere almeno una lettera minuscola, un numero e un carattere speciale',
        lowerNumericSpecialUpper: 'La password deve contenere almeno una lettera minuscola, una lettera maiuscola, un numero e un carattere speciale',
        lowerNumericUpper: 'La password deve contenere almeno una lettera minuscola, una lettera maiuscola e un numero',
        lowerSpecial: 'La password deve contenere almeno una lettera minuscola e un carattere speciale',
        lowerSpecialUpper: 'La password deve contenere almeno una lettera minuscola, una lettera maiuscola e un carattere speciale',
        lowerUpper: 'La password deve contenere almeno una lettera minuscola e una lettera maiuscola',
        numeric: 'La password deve contenere almeno un numero',
        numericSpecial: 'La password deve contenere almeno un numero e un carattere speciale',
        numericSpecialUpper: 'La password deve contenere almeno una lettera maiuscola, un numero e un carattere speciale',
        numericUpper: 'La password deve contenere almeno una lettera maiuscola e un numero',
        special: 'La password deve contenere almeno un carattere speciale',
        specialUpper: 'La password deve contenere almeno una lettera maiuscola e un carattere speciale',
        upper: 'La password deve contenere almeno una lettera maiuscola'
      },
      regex: 'controlli {field}',
      required: ' {field} è richiesto',
      numeric: 'Il campo deve essere numerico',
      thePassword: 'La password',
      uuid: 'Il campo deve essere UUID'
    }
  },
  'fr-FR': {
    validation: {
      default: '{field} non valide',
      domain: 'Domaine non valide',
      email: 'Email non valide',
      malformedJSON: 'JSON non valide',
      maxLength: '{field} ne peut pas dépasser {val} caractères',
      minLength: '{field} doit contenir au moins {val} caractères',
      passwordMatch: 'Les mots de passe ne correspondent pas',
      password: {
        lower: 'Le mot de passe doit contenir au moins une lettre minuscule',
        lowerNumeric: 'Le mot de passe doit contenir au moins une lettre minuscule et un chiffre',
        lowerNumericSpecial: 'Le mot de passe doit contenir au moins une lettre minuscule, un chiffre et un caractère spécial',
        lowerNumericSpecialUpper: 'Le mot de passe doit contenir au moins une lettre minuscule, une lettre majuscule, un chiffre et un caractère spécial',
        lowerNumericUpper: 'Le mot de passe doit contenir au moins une lettre minuscule, une lettre majuscule et un chiffre',
        lowerSpecial: 'Le mot de passe doit contenir au moins une lettre minuscule et un caractère spécial',
        lowerSpecialUpper: 'Le mot de passe doit contenir au moins une lettre minuscule, une lettre majuscule et un caractère spécial',
        lowerUpper: 'Le mot de passe doit contenir au moins une lettre minuscule et une lettre majuscule',
        numeric: 'Le mot de passe doit contenir au moins un chiffre',
        numericSpecial: 'Le mot de passe doit contenir au moins un chiffre et un caractère spécial',
        numericSpecialUpper: 'Le mot de passe doit contenir au moins une lettre majuscule, un chiffre et un caractère spécial',
        numericUpper: 'Le mot de passe doit contenir au moins une lettre majuscule et un chiffre',
        special: 'Le mot de passe doit contenir au moins un caractère spécial',
        specialUpper: 'Le mot de passe doit contenir au moins une lettre majuscule et un caractère spécial',
        upper: 'Le mot de passe doit contenir au moins une lettre majuscule'
      },
      regex: 'vérifiez {field}',
      required: '{field} est requis',
      numeric: 'Le champ doit être numérique',
      thePassword: 'Le mot de passe',
      uuid: 'Le champ doit être UUID'
    }
  }
}

function capitalizeT (t) {
  return function (key, ...params) {
    const translated = t(key, ...params)
    return translated.charAt(0).toUpperCase() + translated.slice(1)
  }
}

function toLower (val, isRaw) {
  if (isRaw) return val
  return val.toLowerCase()
}

export default function useValidation (i18n = getI18n()) {
  let { t } = mergeMessages(messages, i18n, 'Validation')
  t = capitalizeT(t)
  const validation = reactive({ errors: [], loading: false, rules: [], handlers: [] })

  function getHandlers (props = {}) {
    validation.handlers = []
    const externalVerifications = props.externalVerifications || []
    for (let i = 0; i < externalVerifications.length; i++) {
      if (typeof externalVerifications[i] === 'object') {
        validation.handlers.push(getAsyncRuleHandler(externalVerifications[i]))
      }
    }
    return validation.handlers
  }

  function getRules (paramRules = [], name = '', rawName = false) {
    const rules = []
    for (let i = 0; i < paramRules.length; i++) {
      if (typeof paramRules[i] === 'function') {
        rules.push(paramRules[i](t))
        continue
      }
      const split = paramRules[i].split(':')
      switch (split[0]) {
        case 'numeric':
          rules.push(v => !v || /^[0-9]+$/.test(v) || t('validation.numeric'))
          break
        case 'required':
          rules.push(v => (Array.isArray(v) ? v.length > 0 : !!v) || t('validation.required', { field: toLower(t(name), rawName) }))
          break
        case 'password': {
          let charSets = []
          if (split.length > 1) {
            charSets = split[1].split(',')
          }
          const validationMessage = getKeyFromCharSets(charSets)
          const regex = buildPasswordRegex(charSets)
          rules.push(v => !v || regex.test(v) || t(validationMessage))
          break
        }
        case 'minLength':
          rules.push(v => (!v || v.length >= split[1]) || t('validation.minLength', { field: toLower(t(name), rawName), val: split[1] }))
          break
        case 'maxLength':
          rules.push(v => (!v || v.length <= split[1]) || t('validation.maxLength', { field: toLower(t(name), rawName), val: split[1] }))
          break
        case 'uuid':
          rules.push(v => !v || uuidValidate(v) || t('validation.uuid'))
          break
        case 'regex':
          rules.push(v => ((Array.isArray(v) && v.length === 0) || !v) || (new RegExp(split[1]).test(v)) || t((split[2] || 'validation.regex'), { field: toLower(t(name), rawName) }))
          break
        case 'json':
          rules.push(v => {
            if (!v) {
              return true
            }
            let validJSON = false
            try {
              const o = JSON.parse(v)
              if (o && typeof o === 'object') {
                validJSON = true
              }
            } catch (e) { }
            return validJSON || t('validation.malformedJSON', { field: toLower(t(name), rawName) })
          })
          break
        case 'email':
          rules.push(
            // eslint-disable-next-line no-useless-escape,no-control-regex
            v => !v || /(?:[\u00A0-\uD7FF\uE000-\uFFFF-a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[\u00A0-\uD7FF\uE000-\uFFFF-a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[\u00A0-\uD7FF\uE000-\uFFFF-a-z0-9](?:[\u00A0-\uD7FF\uE000-\uFFFF-a-z0-9-]*[\u00A0-\uD7FF\uE000-\uFFFF-a-z0-9])?\.)+[\u00A0-\uD7FF\uE000-\uFFFF-a-z0-9](?:[\u00A0-\uD7FF\uE000-\uFFFF-a-z0-9-]*[\u00A0-\uD7FF\uE000-\uFFFF-a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(v.toLowerCase()) || t('validation.email'))
          break
      }
    }
    return rules
  }

  function getValidation (props = {}, bus, defaultRules) {
    const rules = props.rules || defaultRules || []
    validation.rules = getRules(rules, props.label, props.rawName)
    validation.handlers = getHandlers(props)
    let skipFirst = true
    const stopValueWatcher = watch(() => props.value, async (v, o) => {
      if (o === null && skipFirst) {
        skipFirst = false
        return
      }
      skipFirst = false
      await validate(v)
    })
    let stopErrorWatcher = () => {}
    let stopLoadingWatcher = () => {}
    if (props.panelID) {
      stopErrorWatcher = watch(() => validation.errors, (err) => {
        bus.$emit('error/' + props.panelID, { id: props.id, error: err.length !== 0 })
      })
      stopLoadingWatcher = watch(() => validation.loading, () => {
        bus.$emit('loading/' + props.panelID, validation.loading)
      })
      bus.$on('reset-validation/' + props.panelID, () => {
        updateErrors(false)
      })
      bus.$on('validate/' + props.panelID, () => {
        validate(props.value)
      })
    }
    const stopRulesWatcher = watch(() => props.rules, (v) => {
      validation.rules = getRules(props.rules, props.label, props.rawName)
    }, { deep: true })
    const stopHandlersWatcher = watch(() => props.externalVerifications, (v) => {
      validation.handlers = getHandlers(props)
    }, { deep: true })

    onUnmounted(() => {
      stopErrorWatcher()
      stopLoadingWatcher()
      stopRulesWatcher()
      stopHandlersWatcher()
      stopValueWatcher()
      bus.$off('reset-validation/' + props.panelID)
      bus.$off('validate/' + props.panelID)
    })
    return validation
  }
  function updateErrorsOnBlur (value) {
    validate(value, true)
  }
  function updateErrors (err, value) {
    const message = getMessage(value)
    if (err) {
      validation.errors.push(message || 'invalid')
    } else {
      while (validation.errors.length > 0) {
        validation.errors.pop()
      }
    }
  }
  async function validate (value, skipAsync) {
    validation.errors.splice(0, validation.errors.length)

    if (!skipAsync) {
      for (const handler of validation.handlers) {
        const response = await handler(value)
        if (!response.valid) {
          const err = t(response.message, response.args)
          validation.errors.push(err)
          return
        }
      }
    }
    for (const rule of validation.rules) {
      const ruleResult = rule(value)
      if (typeof ruleResult !== 'boolean' || !ruleResult) {
        validation.errors.push(ruleResult)
        return
      }
    }
    validation.errors.splice(0, validation.errors.length)
  }
  function getAsyncRuleHandler (ruleObject = {}) {
    let timer
    const countdown = ruleObject.time || 1000
    return async (v) => {
      clearTimeout(timer)
      let invalid = false
      for (const r of validation.rules) {
        const ruleResult = r(v)
        if (typeof ruleResult !== 'boolean' || !ruleResult) {
          invalid = true
        }
      }
      if (v === ruleObject.saved || validation.errors > 0 || invalid) {
        validation.loading = false
        return { valid: true }
      }
      validation.loading = true
      const { valid, message, args } = await new Promise(resolve => {
        timer = setTimeout(async () => {
          const response = await ruleObject.call(v)
          validation.loading = false
          resolve(response)
        }, countdown)
      })
      return { valid, message, args }
    }
  }

  function getMessage (value) {
    for (let i = 0; i < validation.rules.length; i++) {
      if (typeof validation.rules[i] === 'function') {
        const msg = validation.rules[i](value)
        if (typeof msg === 'string') {
          return msg
        }
      }
    }
    return null
  }

  function simpleValidation (props = {}, bus) {
    const stopErrorWatcher = watch(() => validation.errors, (err) => {
      bus.$emit('error/' + props.panelID, { id: props.id, error: err.length !== 0 })
    })
    onUnmounted(() => {
      stopErrorWatcher()
    })
    return validation
  }

  return {
    getRules,
    getValidation,
    simpleValidation,
    getMessage,
    updateErrors,
    updateErrorsOnBlur,
    validate
  }
}

export function usePanelValidation (id = '', bus) {
  const validation = ref({ valid: true, loading: false, errors: {}, validate: () => { bus.$emit('validate/' + id) } })
  const hasErrors = computed(() => {
    for (const field in validation.value.errors) {
      if (validation.value.errors[field]) {
        return true
      }
    }
    return false
  })

  const stopErrorWatcher = watch(() => validation.value.errors, (val) => {
    set(validation.value, 'valid', !validation.value.loading && !hasErrors.value)
  }, {
    deep: true
  })
  let stopValidWatcher = watch(() => validation.value.valid, (val) => {
    bus.$emit('valid/' + id, val)
  }, {
    deep: true
  })
  onUnmounted(() => {
    stopErrorWatcher()
    stopValidWatcher()
  })

  function resetValidation (bhm, ID = id) {
    stopValidWatcher()
    set(validation.value, 'valid', true)
    set(validation.value, 'loading', false)
    for (const key in validation.value.errors) {
      del(validation.value.errors, key)
    }
    stopValidWatcher = watch(() => validation.value.valid, (val) => {
      bus.$emit('valid/' + ID, val)
    }, {
      deep: true
    })
    bus.$emit('reset-validation/' + ID)
    bhm.cleanAll()
    bhm.addHandler(bus, 'error/' + ID, field => {
      set(validation.value.errors, field.id, field.error)
    })
    bhm.addHandler(bus, 'loading/' + ID, loading => {
      set(validation.value, 'loading', loading)
      if (loading) {
        set(validation.value, 'valid', false)
        return
      }
      set(validation.value, 'valid', !validation.value.loading && !hasErrors.value)
    })
  }

  return {
    resetValidation,
    validation
  }
}

function buildPasswordRegex (charSets = []) {
  const defaultPasswordRegex = /^(?=.*[A-ZÀ-ÖØ-Þ])(?=.*[a-zà-öø-ÿ])(?=.*[!¡@#~$%^&*()_+\-=[\]{};':"\\|,.<>/¿?])(?=.*[0-9]).+$/
  if (!charSets || charSets.length === 0) {
    return defaultPasswordRegex
  }
  const lookaheads = []

  for (const charSet of charSets) {
    switch (charSet) {
      case 'upper':
        lookaheads.push('(?=.*[A-ZÀ-ÖØ-Þ])')
        break
      case 'lower':
        lookaheads.push('(?=.*[a-zà-öø-ÿ])')
        break
      case 'special':
        lookaheads.push("(?=.*[!¡@~#$%^&*()_+\\-=\\[\\]{};':\"\\\\|,.<>\\/¿?])")
        break
      case 'numeric':
        lookaheads.push('(?=.*[0-9])')
        break
      default:
        return defaultPasswordRegex
    }
  }
  return new RegExp(`^${lookaheads.join('')}.+$`)
}

function getKeyFromCharSets (charSets) {
  const prefix = 'validation.password.'
  if (!charSets || charSets.length === 0) {
    return prefix + 'lowerNumericSpecialUpper'
  }
  return prefix + charSets
    .sort()
    .map((charSet, index) => {
      if (index === 0) {
        return charSet
      }
      return charSet.charAt(0).toUpperCase() + charSet.slice(1)
    })
    .join('')
}
